(function () {
	const mediaBanner = () => {
		document.querySelectorAll(".media-banner").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			block = $(block);

			const stickyEffect = block.data("sticky-effect");

			if (stickyEffect) {
				var normalElement = document.querySelector(`#${id} + .sticky-section`);
				if (normalElement == null) {
					return;
				}

				var isSticky = false;

				window.addEventListener("scroll", function () {
					var stickyTop = box.getBoundingClientRect().top;
					var normalElementTop = normalElement.getBoundingClientRect().top;

					if (stickyTop <= 0 && !isSticky) {
						box.classList.add("sticky-active");
						isSticky = true;
					}

					if (normalElementTop <= 0 && isSticky) {
						box.classList.remove("sticky-active");
						isSticky = false;
					}
				});
			}
		});
	};

	const mobileMq = window.matchMedia("(max-width: 749px)");

	const isWrapActive = (wrap) => {
		if (wrap.classList.contains("media-banner__video--mobile")) return mobileMq.matches;
		if (wrap.classList.contains("media-banner__video--desktop")) return !mobileMq.matches;
		return true;
	};

	const setIframePlayback = (iframe, play) => {
		if (!iframe?.contentWindow) return;
		if (iframe.classList.contains("js-youtube")) {
			iframe.contentWindow.postMessage(
				JSON.stringify({
					event: "command",
					func: play ? "playVideo" : "pauseVideo",
					args: "",
				}),
				"*"
			);
			return;
		}
		if (iframe.classList.contains("js-vimeo")) {
			iframe.contentWindow.postMessage(
				JSON.stringify({
					method: play ? "play" : "pause",
				}),
				"*"
			);
		}
	};

	const playHeroVideos = () => {
		document.querySelectorAll(".media-banner__video").forEach((wrap) => {
			const active = isWrapActive(wrap);
			const video = wrap.querySelector("video");
			const iframe = wrap.querySelector("iframe");
			const content = wrap.closest(".media-banner__content");
			const soundButton = content?.querySelector(".js-sound-video");
			const playButton = content?.querySelector(".js-play-video");
			const userPaused = playButton?.dataset.userPaused === "true";

			if (video) {
				if (!soundButton?.classList.contains("active")) {
					video.muted = true;
					video.defaultMuted = true;
					video.setAttribute("muted", "");
				}
				video.playsInline = true;
				video.setAttribute("playsinline", "");
				video.setAttribute("webkit-playsinline", "");

				if (!video.dataset.tnsHeroBound) {
					video.dataset.tnsHeroBound = "true";
					video.addEventListener("playing", () => video.classList.add("is-ready"));
					const retryPlay = () => {
						if (!isWrapActive(wrap)) return;
						const button = wrap.closest(".media-banner__content")?.querySelector(".js-play-video");
						if (button?.dataset.userPaused === "true") return;
						video.play().catch(() => {});
					};
					video.addEventListener("canplay", retryPlay);
					video.addEventListener("loadeddata", retryPlay);
				}

				if (!active) {
					video.pause();
					video.autoplay = false;
					video.classList.remove("is-ready");
				} else if (!userPaused) {
					video.autoplay = true;
					video.preload = "auto";
					video.play().catch(() => {});
				}
			}

			if (iframe) {
				setIframePlayback(iframe, active && !userPaused);
			}
		});
	};

	const startHeroVideos = () => {
		mediaBanner();
		playHeroVideos();
	};

	if (typeof mobileMq.addEventListener === "function") {
		mobileMq.addEventListener("change", playHeroVideos);
	} else if (typeof mobileMq.addListener === "function") {
		mobileMq.addListener(playHeroVideos);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", startHeroVideos);
	} else {
		startHeroVideos();
	}

	window.addEventListener("pageshow", playHeroVideos);
	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState === "visible") playHeroVideos();
	});
	document.addEventListener(
		"pointerdown",
		() => {
			playHeroVideos();
		},
		{ once: true, passive: true }
	);
	document.addEventListener("shopify:section:load", startHeroVideos);
})();

//document.addEventListener("DOMContentLoaded", function () {
//	var stickyElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner"
//	);
//	var normalElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner-2"
//	);
//	var isSticky = false; // Track whether the element is sticky

//	window.addEventListener("scroll", function () {
//		var stickyTop = stickyElement.getBoundingClientRect().top;
//		var normalElementTop = normalElement.getBoundingClientRect().top;

//		// Add sticky class when sticky element reaches the top of the viewport
//		if (stickyTop <= 0 && !isSticky) {
//			stickyElement.classList.add("sticky-active");
//			isSticky = true; // Set sticky state to true
//		}

//		// Remove sticky class if the second section is in the viewport
//		if (normalElementTop <= 0 && isSticky) {
//			stickyElement.classList.remove("sticky-active");
//			isSticky = false; // Set sticky state to false
//		}
//	});
//});
